// import React from "react";
// import Slider from "react-slick";
// import "./HeroCarousel.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const images = [
//   {
//     url: "https://spinellejewelry.com/cdn/shop/files/gemstone.jpg?v=1720000256&width=1100",
//     title: "Timeless Gemstone Elegance",
//     subtitle: "Crafted for Moments That Matter",
//     highlight: "Discover our newest gemstone rings."
//   },
//   {
//     url: "https://spinellejewelry.com/cdn/shop/files/halo.jpg?v=1718440930&width=750",
//     title: "Radiant Halo Collection",
//     subtitle: "A Sparkle Above the Rest",
//     highlight: "Brilliance redefined in every piece."
//   }
// ];

// const HeroCarousel = () => {
//   const settings = {
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     speed: 800,
//     slidesToShow: 1,
//     slidesToScroll: 1
//   };

//   return (
//     <div className="hero-carousel">
//       <Slider {...settings}>
//         {images.map((img, i) => (
//           <div className="carousel-slide" key={i}>
//             <img src={img.url} alt="Jewelry" className="carousel-image" />
//             <div className="top-right-logo">SPINELLE ✦</div>
//             <div className="overlay-text">
//               <h2>{img.title}</h2>
//               <p>{img.subtitle}</p>
//               <span className="highlight">{img.highlight}</span>
//             </div>
//             <div className="special-ribbon">🎁 Special Offer</div>
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default HeroCarousel;


import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios"; // Import axios for API requests
import "./HeroCarousel.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HeroCarousel = () => {
  const [carouselData, setCarouselData] = useState({
    images: [],
    titles: [],
    subtitles: [],
    highlights: []
  });

  useEffect(() => {
    // Fetch Hero Carousel data from API
    const fetchCarouselData = async () => {
      try {
        const response = await axios.get('https://spinelleapi.emedha.in/admin/advertise/get/advertise');
        const heroCarouselData = response.data.data.find(ad => ad.type === "Hero Carousel");

        if (heroCarouselData) {
          setCarouselData({
            images: heroCarouselData.carousel_images,
            titles: heroCarouselData.carousel_titles,
            subtitles: heroCarouselData.carousel_subtitles,
            highlights: heroCarouselData.carousel_highlights
          });
        }
      } catch (error) {
        console.error("Error fetching carousel data:", error);
      }
    };

    fetchCarouselData();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <div className="hero-carousel">
      <Slider {...settings}>
        {carouselData.images.length > 0 ? (
          carouselData.images.map((img, i) => (
            <div className="carousel-slide" key={i}>
              <img src={img} alt="Jewelry" className="carousel-image" />
              <div className="top-right-logo">SPINELLE ✦</div>
              <div className="overlay-text">
                <h2>{carouselData.titles[i]}</h2>
                <p>{carouselData.subtitles[i]}</p>
                <span className="highlight">{carouselData.highlights[i]}</span>
              </div>
              <div className="special-ribbon">🎁 Special Offer</div>
            </div>
          ))
        ) : (
          <div>Loading...</div>
        )}
      </Slider>
    </div>
  );
};

export default HeroCarousel;
